export const AUTH_BROADCAST_CHANNEL = 'auth-state';

export const broadcastLogout = () => {
  const channel = new BroadcastChannel(AUTH_BROADCAST_CHANNEL);
  channel.postMessage({ type: 'logout' });
  channel.close();
};
